"use client";

import { useInitializeLocalization } from "@faire/retailer/useInitializeLocalization";

export const LocalizationInitializer: React.FC = () => {
  useInitializeLocalization();
  return null;
};
